import type { Bonus } from '../types/content'

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: '200 Wrestling Drills & Training Games',
    headline:
      'The ultimate drill library for technique, reactions, conditioning and competitive development',
    value: '15',
    points: [
      'Stance and motion, hand fighting, takedowns and takedown defense',
      'Top wrestling, bottom wrestling, escapes and re-attacks',
      'Scrambles, situational wrestling, conditioning and competition',
      'Each drill includes purpose, setup, execution, coaching cues and progressions',
    ],
    benefit: 'More drills. More variety. Better practices.',
  },
  {
    id: '2',
    title: 'Opponent Scouting & Match Analysis Playbook',
    headline:
      'A complete system for reading opponents, identifying patterns and building smarter match strategies',
    value: '12',
    points: [
      'Stance, movement, preferred attacks and setups',
      'Defensive reactions, top and bottom wrestling tendencies',
      'Pace, conditioning and score behavior',
      'Match patterns and tactical opportunities',
    ],
    benefit: 'Observe. Identify. Analyze. Build the plan.',
  },
  {
    id: '3',
    title: 'Tournament Day Coach Toolkit',
    headline:
      'Warm-ups, match preparation, between-match routines, corner coaching and competition-day management',
    value: '12',
    points: [
      'Tournament arrival, pre-match preparation and wrestling warm-ups',
      'Athlete readiness, match-side coaching, score and clock cues',
      'Between-match recovery and post-match feedback',
      'Managing wins, managing losses and multiple-match tournament days',
    ],
    benefit: 'Know what to do before, during and after every match.',
  },
  {
    id: '4',
    title: '52-Week Wrestling Training Planner',
    headline:
      'A full-year coaching roadmap for technique, drilling, competition, recovery and athlete development',
    value: '12',
    points: [
      'Foundation blocks and technical development',
      'Chain wrestling development and early competition',
      'Main competition season and championship preparation',
      'Post-season recovery, off-season development and weekly coaching priorities',
    ],
    benefit: 'Stop planning one practice at a time. Start seeing the whole season.',
  },
  {
    id: '5',
    title: '100 Warm-Ups, Movement Games & Conditioning Finishers',
    headline:
      'Ready-to-use activities for faster starts, better movement and stronger practice finishes',
    value: '12',
    points: [
      'Wrestling-specific warm-ups, reaction games and movement games',
      'Partner activities and technical activation',
      'Shot intervals, sprawl intervals and position battles',
      'Competitive finishers and recovery activities',
    ],
    benefit: 'Every warm-up prepares the skill. Every finisher reinforces the wrestling.',
  },
]

export const bonusValueRows: { label: string; value: string }[] = [
  { label: 'Bonus 1 — 200 Wrestling Drills & Training Games', value: '$15' },
  { label: 'Bonus 2 — Opponent Scouting & Match Analysis Playbook', value: '$12' },
  { label: 'Bonus 3 — Tournament Day Coach Toolkit', value: '$12' },
  { label: 'Bonus 4 — 52-Week Wrestling Training Planner', value: '$12' },
  { label: 'Bonus 5 — 100 Warm-Ups, Movement Games & Finishers', value: '$12' },
]
